<template>
  <!--
    Vuetify 2 の形式だった部分 を以下となるようVuetify 3用に修正。
    縦積み：isColumn が true のとき v-row に flex-column を付与
    グリッド：Vuetify 3 形式の cols="12" + :md="firstMd" / :md="secondMd" に統一
    グリッドサイズ：created の壊れたロジックを削除し、computed で firstGridSize ?? 6 を使用
    reverse：横並び時に flex-row-reverse で左右を入れ替え
    縦積みになる条件: 幅 959px 以下
     （smAndDown）のとき isColumn = true → flex-column + 各カラム cols=12 で first → second の順に積み上がります。
  -->
  <v-row
    class="mb-4"
    :class="{
      'flex-column': isColumn,
      'flex-row-reverse': !isColumn && reverse,
      'ga-5': isColumn
    }"
  >
    <v-col
      :cols="12"
      :md="firstMd"
    >
      <slot name="first" />
    </v-col>

    <v-col
      :cols="12"
      :md="secondMd"
    >
      <slot name="second" />
    </v-col>
  </v-row>
</template>

<script>
  export default {
    props: {
      reverse: Boolean,
      firstGridSize: { type: Number, default: null },
      secondGridSize: { type: Number, default: null },
      columnScreenSize: { type: String, default: 'smAndDown' }
    },
    computed: {
      firstMd () {
        return this.firstGridSize ?? 6
      },
      secondMd () {
        return this.secondGridSize ?? 6
      },
      isColumn () {
        if (this.columnScreenSize === 'smAndDown') {
          // smAndDown < 960px
          return this.$vuetify.display.smAndDown
        } else if (this.columnScreenSize === 'mdAndDown') {
          // mdAndDown < 1280px
          return this.$vuetify.display.mdAndDown
        } else if (this.columnScreenSize === 'lgAndDown') {
          // lgAndDown < 1919px
          return this.$vuetify.display.lgAndDown
        }
        return false
      }
    }
  }
</script>
